import React from 'react';
import classnames from 'classnames';
import { BiLink } from '../../../biLogger';
import s from './DuperbrowsePaddles.scss';
export var DuperbrowsePaddle = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, isEnabled = _a.isEnabled, dataHook = _a.dataHook, biData = _a.biData;
    return (React.createElement("div", { className: classnames(s['duper'], className, isEnabled && s['enabled']), "data-hook": dataHook }, isEnabled ? (React.createElement(BiLink, { biData: biData, onClick: onClick }, children)) : (React.createElement(React.Fragment, null, children))));
};
DuperbrowsePaddle.displayName = 'DuperbrowsePaddle';
export default DuperbrowsePaddle;
//# sourceMappingURL=DuperbrowsePaddle.js.map